import './Input.css';

function Input({
  type = 'text',
  name,
  id,
  value,
  onChange,
  placeholder,
  label,
  error,
  required = false,
  disabled = false,
  lang = 'he', // 'he' for Hebrew (RTL), 'en' for English (LTR)
  width = '100%',
  className = '',
  ...props
}) {
  const isRTL = lang === 'he';
  const inputId = id || name;
  
  return (
    <div 
      className={`input-wrapper ${error ? 'has-error' : ''} ${className}`}
      style={{ width }}
    >
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label}
          {required && <span className="required-star">*</span>}
        </label>
      )}
      <input
        type={type}
        id={inputId}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        className={`input-field ${isRTL ? 'input-rtl' : 'input-ltr'}`}
        dir={isRTL ? 'rtl' : 'ltr'}
        {...props}
      />
      {error && <span className="input-error">{error}</span>}
    </div>
  );
}

export default Input;

